import { Button, Group, List, Modal, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FaCircleCheck } from 'react-icons/fa6';

export default function OAuthInfosModal({ data, onConnect, onClose }) {
    return <Modal
        opened={!!data}
        onClose={onClose}
        title={<Title order={3}>Conectar Instagram/Facebook</Title>}
    >
        <Stack>
            <List
                spacing="xl"
                size="md"
                center
                icon={
                    <ThemeIcon color="teal" size={24} radius="xl">
                        <FaCircleCheck size={16} />
                    </ThemeIcon>
                }
            >
                <List.Item>Necessário que a página do Facebook também esteja conectada no portfólio empresarial</List.Item>
                <List.Item>Necessário que a conta do Instagram esteja vinculada à página</List.Item>
                <List.Item>Necessário que a conta do Instagram seja do tipo <strong>Business</strong></List.Item>
            </List>

            <div className="aspect-w-16 aspect-h-9">
                <iframe
                    src="https://www.youtube.com/embed/Biz1An-Pa0s"
                    title="Tutorial Instagram/Facebook"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ width: '100%', minHeight: 200 }}
                    frameBorder={0}
                ></iframe>
            </div>

            <Text size="md">
                Qualquer tenha alguma dúvida, fale com nosso suporte
            </Text>

            <Group style={{ justifyContent: 'flex-end' }}>
                <Button
                    onClick={() => {
                        window.open("https://wa.me/message/BPMD4C7JRJTDA1", "_blank")
                    }}
                    color="green"
                    variant='outline'
                    leftIcon={<FaWhatsapp />}
                >Falar com Suporte</Button>
                <Button
                    onClick={onConnect}
                >Conectar</Button>
            </Group>
        </Stack>
    </Modal>
}